import React from "react";
import { Box, Radio } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicRadioSize = () => {
  return (
    <Box sx={{ mb: 2 }}>
      <PreviewAndEditor  language={"js"} value={"        <Radio size=\"small\" />\n" +
          "        <Radio size=\"medium\" />\n" +
          "        <Radio size=\"large\" />"}>
        <Radio size="small" />
        <Radio size="medium" />
        <Radio size="large" />
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicRadioSize;
